import React, { useEffect, useState } from 'react';
import styled from 'styled-components';
import moment from 'moment';
import Input from '~~elements/Input';
import Button from '~~elements/Button';
import Select from '~~elements/Select';
import UploadImages from '~~elements/UploadImages';
import DefaultPlayerAvatarJPG from '~~elements/static/DefaultPlayerAvatar.jpg';
import { PlayerResource } from '~~apis/resource';
import PlayerHeader from './PlayerHeader';
import { TwoColumnStyledForm } from '../Styles';
import TTMultilingual from '../../Tournament/TournamentTeam/Multilingual';
import { playerPositionOptions, playerHandOptions } from '../../Tournament/Const';

const StyledDiv = styled.div`
  display: flex;
  flex-direction: column;
  align-items: start;
  width: 100%;
  letter-spacing: 1px;
  padding-top: 2rem;
  .player-avatar {
    width: 8rem;
    height: 8.96rem;
    // 3.5 : 4.5
  }
`;

const PlayerProfile = ({ players, reload }) => {
  const [playerIndex, setPlayerIndex] = useState(0);

  const [playerData, setPlayerData] = useState(players[0]);
  const [errorMsg, setErrorMsg] = useState('');
  const [successMsg, setSuccessMsg] = useState('');

  useEffect(() => {
    const playerInfo = players[playerIndex].info;
    setPlayerData({
      ...playerInfo,
      birthday:
        !playerInfo.birthday || !moment(playerInfo.birthday).isValid()
          ? ''
          : moment(playerInfo.birthday).format('YYYY-MM-DD'),
    });
  }, [playerIndex, players]);

  const handleInputOnchange = (e) => {
    setPlayerData({
      ...playerData,
      [e.target.name]: e.target.value,
    });
  };

  const handleSocialMediaOnchange = (e) => {
    const socialMedia = playerData.social_media;
    if (!socialMedia[e.target.name]) {
      socialMedia[e.target.name] = {
        link: e.target.value,
      };
    } else {
      socialMedia[e.target.name].link = e.target.value;
    }
    setPlayerData({
      ...playerData,
      social_media: socialMedia,
    });
  };

  const handleAvatarUpdate = (images) => {
    if (images.length !== 1) {
      return;
    }
    const { url, path } = images[0];
    if (!url || !path) {
      return;
    }

    setPlayerData({
      ...playerData,
      avatar_url: url,
      avatar_path: path,
    });
  };

  const handleAvatarRemove = (e) => {
    e.preventDefault();
    setPlayerData({
      ...playerData,
      avatar_url: '',
      avatar_path: 'REMOVE',
    });
  };

  const handleAvatarCancel = (e) => {
    e.preventDefault();
    setPlayerData({
      ...playerData,
      avatar_url: players[playerIndex].info.avatar_url,
      avatar_path: players[playerIndex].info.avatar_path,
    });
  };

  const updateProfile = () => {
    PlayerResource.updateProfile({
      playerUniqid: players[playerIndex].info.uniqid,
      data: {
        ...playerData,
      },
    })
      .then(() => {
        setSuccessMsg('更新成功！');
        setTimeout(() => reload(), 1000);
      })
      .catch((e) => {
        console.log(e);
        setErrorMsg('更新失敗！請檢查資料或稍候再試');
      });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    setSuccessMsg('');
    setErrorMsg('');

    if (!!playerData.social_media?.INSTAGRAM?.link && !playerData.social_media.INSTAGRAM.link.match(/^[0-9a-z._]+$/)) {
      return setErrorMsg('IG 帳號格式有誤，僅能包含 0-9 a-z 與 . _ 符號');
    }
    if (
      !!playerData.social_media?.FACEBOOK?.link &&
      !playerData.social_media.FACEBOOK.link.match(/^https:\/\/www.facebook.com\/.*$/)
    ) {
      return setErrorMsg('facebook 連結格式有誤，開頭需為 https://www.facebook.com/');
    }

    return updateProfile();
  };

  return (
    <StyledDiv>
      {players.length > 0 && (
        <PlayerHeader players={players} playerIndex={playerIndex} setPlayerIndex={setPlayerIndex} />
      )}
      <TwoColumnStyledForm onSubmit={handleSubmit}>
        <div className="box">
          {/* 球員名稱 */}
          <label>球員名稱</label>
          <div className="input-field">
            <div className="input-box">
              <Input width="100%" placeholder="球員名稱" name="name" value={playerData.name} disabled />
            </div>
          </div>
          {/* 球員生日 */}
          <label>{TTMultilingual(`COLUMN.BIRTHDAY`)}</label>
          <div className="input-field">
            <div className="input-box">
              <Input type="date" name="birthday" value={playerData.birthday} onChange={handleInputOnchange} />
            </div>
          </div>
          {/* 主要守位 */}
          <div className="input-field">
            <div className="input-box">
              <label>{TTMultilingual(`COLUMN.FIRST_POSITION`)}</label>
              <Select name="first_position" onChange={handleInputOnchange} value={playerData.first_position}>
                {playerPositionOptions.map((key) => (
                  <option key={key} value={key}>
                    {TTMultilingual(`POSITION.${key}`)}
                  </option>
                ))}
              </Select>
            </div>
          </div>
          {/* 次要守位 */}
          <div className="input-field">
            <div className="input-box">
              <label>{TTMultilingual(`COLUMN.SECOND_POSITION`)}</label>
              <Select name="second_position" onChange={handleInputOnchange} value={playerData.second_position}>
                {playerPositionOptions.map((key) => (
                  <option key={key} value={key}>
                    {TTMultilingual(`POSITION.${key}`)}
                  </option>
                ))}
              </Select>
            </div>
          </div>
          {/* 投球用手 */}
          <div className="input-field">
            <div className="input-box">
              <label>{TTMultilingual(`COLUMN.P_HAND`)}</label>
              <Select name="p_hand" onChange={handleInputOnchange} value={playerData.p_hand}>
                {playerHandOptions.map((key) => (
                  <option key={key} value={key}>
                    {TTMultilingual(`HAND.${key}`)}
                  </option>
                ))}
              </Select>
            </div>
          </div>
          {/* 打擊用手 */}
          <div className="input-field">
            <div className="input-box">
              <label>{TTMultilingual(`COLUMN.B_HAND`)}</label>
              <Select name="b_hand" onChange={handleInputOnchange} value={playerData.b_hand}>
                {playerHandOptions.map((key) => (
                  <option key={key} value={key}>
                    {TTMultilingual(`HAND.${key}`)}
                  </option>
                ))}
              </Select>
            </div>
          </div>
          {/* 社群連結 */}
          <div className="input-field">
            <div className="input-box">
              <label>instagram</label>
              <Input
                width="100%"
                placeholder="IG 帳號"
                name="INSTAGRAM"
                onChange={handleSocialMediaOnchange}
                value={playerData.social_media?.INSTAGRAM ? playerData.social_media.INSTAGRAM.link : ''}
              />
            </div>
          </div>
          <div className="input-field">
            <div className="input-box">
              <label>facebook</label>
              <Input
                width="100%"
                placeholder="https://www.facebook.com/xxx"
                name="FACEBOOK"
                onChange={handleSocialMediaOnchange}
                value={playerData.social_media?.FACEBOOK ? playerData.social_media.FACEBOOK.link : ''}
              />
            </div>
          </div>
          <div className="error-msg">{errorMsg}</div>
          <div className="success-msg">{successMsg}</div>
          <Button width="unset" nowrap type="submit" onClick={handleSubmit}>
            更新
          </Button>
        </div>
        <div className="icon">
          {playerData.avatar_url ? (
            <img className="icon--pic square player-avatar" src={playerData.avatar_url} alt="avatar" />
          ) : (
            <img className="icon--pic square player-avatar" src={DefaultPlayerAvatarJPG} alt="default avatar" />
          )}
          <div className="icon--box">
            {playerData.avatar_url === players[playerIndex].info.avatar_url ? (
              <>
                <UploadImages
                  url="/api/media"
                  customBtn={(onClick) => (
                    <Button mini nowrap width="unset" color="blue" onClick={onClick}>
                      更改
                    </Button>
                  )}
                  onChange={handleAvatarUpdate}
                />
                <Button mini nowrap width="unset" color="transparent" onClick={handleAvatarRemove}>
                  移除
                </Button>
              </>
            ) : (
              <Button mini nowrap width="unset" color="transparent" onClick={handleAvatarCancel}>
                取消
              </Button>
            )}
          </div>
        </div>
      </TwoColumnStyledForm>
    </StyledDiv>
  );
};

export default PlayerProfile;
